/**
 * ATELIER LUXURY SHOPIFY THEME - FACETS & COLLECTION FILTERING ENGINE
 */

const safeDebounce = (fn, wait) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), wait);
  };
};

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.initEvents();
  }

  initEvents() {
    this.form?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.onSubmit();
    });

    this.addEventListener('change', (e) => {
      if (e.target.type === 'checkbox' || e.target.tagName === 'SELECT') {
        this.onSubmit();
      }
    });

    const priceInputs = this.querySelectorAll('.price-range__input');
    const debouncedSubmit = typeof debounce === 'function' ? debounce(() => this.onSubmit(), 500) : safeDebounce(() => this.onSubmit(), 500);
    priceInputs.forEach((input) => {
      input.addEventListener('input', debouncedSubmit);
    });

    // Close other disclosures when one opens
    this.querySelectorAll('.facets__disclosure summary').forEach((summary) => {
      summary.addEventListener('click', (e) => {
        const currentDetails = summary.closest('details');
        this.querySelectorAll('.facets__disclosure').forEach((details) => {
          if (details !== currentDetails) {
            details.removeAttribute('open');
          }
        });
      });
    });

    // Intercept remove filter clicks
    this.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-remove-filter]');
      if (removeBtn) {
        e.preventDefault();
        this.fetchFilteredPage(removeBtn.getAttribute('href'));
      }
    });

    window.addEventListener('popstate', (e) => {
      if (e.state && e.state.searchParams) {
        this.fetchFilteredPage(`${window.location.pathname}?${e.state.searchParams}`, false);
      }
    });
  }

  onSubmit() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${searchParams}`;
    this.fetchFilteredPage(url, true);
  }

  async fetchFilteredPage(url, updateHistory = true) {
    const productGrid = document.getElementById('ProductGridContainer');
    if (productGrid) productGrid.style.opacity = '0.4';

    try {
      const res = await fetch(url);
      const text = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      // Update Product Grid
      const newGrid = doc.getElementById('ProductGridContainer');
      if (productGrid && newGrid) {
        productGrid.innerHTML = newGrid.innerHTML;
        productGrid.style.opacity = '1';
      }

      // Update Facet active filters & counts
      const newFacets = doc.querySelector('facet-filters-form');
      if (newFacets) {
        this.innerHTML = newFacets.innerHTML;
        this.form = this.querySelector('form');
        this.initEvents();
      }

      // Update product count
      const countEl = document.getElementById('ProductCount');
      const newCountEl = doc.getElementById('ProductCount');
      if (countEl && newCountEl) {
        countEl.innerHTML = newCountEl.innerHTML;
      }

      if (updateHistory) {
        window.history.pushState({ searchParams: url.split('?')[1] || '' }, '', url);
      }
    } catch (err) {
      console.error('Filtering error:', err);
      if (productGrid) productGrid.style.opacity = '1';
    }
  }
}

if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
}

// Global click-outside listener to close any open facet dropdowns
document.addEventListener('click', (e) => {
  if (!e.target.closest('.facets__disclosure')) {
    document.querySelectorAll('.facets__disclosure[open]').forEach((detail) => {
      detail.removeAttribute('open');
    });
  }
});

